export default __webpack_public_path__ + "static/media/FemaleSoccerBanner.a1e7e5e5.png";